// src/redux/reducer/admin/services/servicesReducer.js
import {
  SET_ALL_DATA_OF_ADMIN_SERVICES,
  SET_FILTERED_ADMIN_SERVICES,
  RESET_ALL_ADMIN_SERVICES_DATA,
  SET_SERVICES_ADMIN_SERVICES,
  SET_PAGES_DATA_ADMIN_SERVICES,
} from "../../../action/admin/services/type";

const initialState = {
  page: 0,
  total: 0,
  pages: 0,
  services: [],
  filtered: [],
  loaded: false,
};

const adminServicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ALL_DATA_OF_ADMIN_SERVICES:
      return {
        ...state,
        page: action.payload?.page,
        total: action.payload?.total,
        pages: action.payload?.pages,
        services: action.payload?.services,
        filtered: action.payload?.services,
        loaded: true,
      };

    case SET_SERVICES_ADMIN_SERVICES:
      return {
        ...state,
        services: action?.payload,
      };

    case SET_FILTERED_ADMIN_SERVICES:
      return {
        ...state,
        filtered: action.payload,
      };

    case SET_PAGES_DATA_ADMIN_SERVICES:
      return {
        ...state,
        page: action?.payload?.page,
        pages: action?.payload?.pages,
        total: action?.payload?.total,
      };

    case RESET_ALL_ADMIN_SERVICES_DATA:
      return {
        ...state,
        ...initialState,
      };

    default:
      return state;
  }
};

export default adminServicesReducer;